
<div class="row mt-3 mb-2">
  <div class="col-12">
    <div class="caption">Условия выплат на застройщике {{developerCaption}}</div>
  </div>
  <div class="col-3 col-sm-4 col-md-6 col-xl-8 pt-3">
    Всего: <b>{{count}}</b>
  </div>
  <!--  <div class="col-6">-->
  <!--    <div class="form__group">-->
  <!--      <div class="form__input mt-3">-->
  <!--        <input class="input" type="text" placeholder="Поиск"-->
  <!--               [(ngModel)]="searchValue">-->
  <!--        <div class="form__input_icon icon icon_Small_Search c-pointer ng-star-inserted"></div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<div class="col-5 col-sm-4 col-md-3 col-xl-2 mt-2 text-right">
  <button type="button" class="button button_sm" (click)="rewriteCondition()" [disabled]="!activeRewriteButton">
    <span class="d-none d-md-inline">Перезаписать</span><span class="d-md-none">Перез-ть</span> УВ и КВ
  </button>
</div>
<div class="col-4 col-md-3 col-xl-2 mt-2 text-right">
  <a type="button" class="button button_sm" href="javascript: void(0)" [routerLink]="['create']">
    Создать УВ
  </a>
</div>
</div>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        @for (el of head; track el) {
          <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
            <div [formGroup]="form">
              <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                <div class="col table__input">
                  @if (el.input) {
                    <app-material-input
                      [placeholder] = "el.caption"
                      [formControlName] = "el.name"
                      [cssClass]="'mb-0'">
                    </app-material-input>
                  }
                  @if (el.select) {
                    <app-material-select
                      [formControlName]="el.name"
                      [cssClass]="'mb-0'"
                      [placeholder]="el.caption"
                      >
                      @for (opt of el.select; track opt) {
                        <option [value]="opt.id">{{opt.caption}}</option>
                      }
                    </app-material-select>
                  }
                  @if (!el.input && !el.select) {
                    {{el.caption}}
                  }
                </div>
                @if (el.sort) {
                  <div class="col-auto">
                    <a href="javascript:void(0)" (click)="sortChange(el.name)">
                  <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          </th>
        }
      </tr>
      @if (rows && rows.length === 0) {
        <tr>
          <td [attr.colspan]="head.length">
            <div class="py-2">
              Записи отсутствуют.
            </div>
          </td>
        </tr>
      }
      @for (row of rows; track row; let row_index = $index) {
        <tr>
          <td>
            <span> {{row['date_from']}}</span>
          </td>
          <td>
            <span> {{row['date_to']}}</span>
          </td>
          <!--        <td>-->
          <!--          <popover-content #popoverInfo-->
          <!--                           [title]="'Условия выплат'"-->
          <!--                           [placement]="'auto'"-->
          <!--                           [closeOnClickOutside]="true"-->
          <!--                           [closeOnMouseOutside]="false">-->
          <!--            <p class="mb-0">-->
          <!--              {{row.text}}-->
        <!--            </p>-->
      <!--          </popover-content>-->
      <!--          <div [popover]="popoverInfo">-->
      <!--            <i class="fa fa-fw fa-question-circle c-pointer text-danger"></i>-->
    <!--          </div>-->
  <!--        </td>-->
  <td>
    <a class="" href="javascript: void(0)"
      (click)="viewDetailInfo(row['text'], $event)">
      Подробнее
    </a>
  </td>
  <td>
    <a href="javascript: void(0)" [routerLink]="['edit', row['id']]">
      Редактировать
    </a>
  </td>
</tr>
}
</table>
</div>
</div>
@if (modalShow) {
  <app-modal [caption]="modalCaption" (onClosed)="modalClose()">
    <textarea style="padding-left:0;background-color:#F9F9F9!important;"
      class="textarea" disabled="disabled" [rows]="20"
    >{{modalContent}}</textarea>
  </app-modal>
}
<div class="alt-pagination">
  <app-paginator
    [queryParams]="filterColumns"
    [itemsPerPage]="10"
    [itemCount]="count"
    [currentPage]="currentPage"
    [baseUrl]="'/condition/developer/' + 1">
  </app-paginator>
</div>

@if (data['imp_settings'] && data['imp_settings'].length) {
  <div class="mb-3">
    <app-alert-danger>
      <p class="text-danger mb-2">
        <i class="fa-fw fa fa-warning mr-3"></i> <b>Внимание!</b>
      </p>
      <p class="mb-3">
        Некоторые или все ЖК данного застройщика имеют источник XML,
        для установки комиссионного вознаграждения на ЖК, следует перейти на соответствующие формы внутри фидов импорта,
        после сохранения там - данные перенесутся сюда. Но не наоборот.:
      </p>
      <ul class="mb-0">
        @for (el of data['imp_settings']; track el; let isLast = $last) {
          <li class="ml-3" [class.mb-2]="!isLast">
            <a [routerLink]="['/import/edit', el.id, 'realization']">
              <i class="mr-2 text-sm icon icon_xml-icon"></i>
              {{ el.caption }}
            </a>
          </li>
        }
      </ul>
    </app-alert-danger>
  </div>
}

<form class="form form_crm" [formGroup]="formGroup" novalidate>
  <div class="row no-gutters gutters-4 align-items-center" formGroupName="default">
    <div class="col-12 mb-2">
      <div class="caption">Общие настройки для реализации квартир на проектах {{developerCaption}}</div>
    </div>
    <div class="col-6 col-md-3 pt-2">
      <app-material-input-checkbox formControlName="is_active">
        Принимать на реализацию
      </app-material-input-checkbox>
    </div>
    <!--    <div class="col-4">-->
    <!--      <app-material-input formControlName="voznagr_agenta" [placeholder]="'Вознаграждение агента (ДБ)'">-->
    <!--        Вознаграждение агента (ДБ)-->
  <!--      </app-material-input>-->
<!--    </div>-->
<!--    <div class="col-4">-->
<!--      <app-material-input formControlName="dolya_subagenta_db" [placeholder]="'Процент субагента (ДБ)'">-->
<!--        Процент субагента ДБ (Доля <span class="bold">{{ formGroup.get('default').get('voznagr_agenta').value | partRate : formGroup.get('default').get('dolya_subagenta_db').value : 'front'}}</span>)-->
<!--      </app-material-input>-->
<!--    </div>-->
<div class="col-6 col-md-3">
  <app-material-input-datepicker formControlName="date_to" [placeholder]="'Действует до'">
    Действует до
  </app-material-input-datepicker>
</div>
<div class="col-6 col-md-3">
  <app-material-input formControlName="flat_agent_ddu_percent" [placeholder]="'Вознаграждение агента (ДДУ)'">
    Вознаграждение агента (ДДУ)
  </app-material-input>
</div>
<div class="col-6 col-md-3">
  <app-material-input formControlName="flat_sa_agd_percent" [placeholder]="'Процент субагента (АГД)'">
    Процент субагента АГД (Доля <span class="bold">{{ formGroup.get('default').get('flat_agent_ddu_percent').value | partRate : formGroup.get('default').get('flat_sa_agd_percent').value : 'front'}}</span>)
  </app-material-input>
</div>
<!--    <div class="col-sm-12">-->
<!--      <app-material-input formControlName="unique_term_days" [placeholder]="'Срок уникальности клиента'">-->
<!--        Срок уникальности клиента-->
<!--      </app-material-input>-->
<!--    </div>-->
<!--    <div class="col-sm-12">-->
<!--      <app-material-input-checkbox formControlName="lead_transfer_capability">-->
<!--        Возможность передачи лида субагентом-->
<!--      </app-material-input-checkbox>-->
<!--    </div>-->
<!--    <div class="col-sm-12">-->
<!--      <div [hidden]="!formGroup.get('default').get('lead_transfer_capability').value">-->
<!--        <app-material-input formControlName="lead_transfer_sub_percent_db" [placeholder]="'Процент субагента ДБ при передаче лида'">-->
<!--          Процент субагента ДБ при передаче лида-->
<!--        </app-material-input>-->
<!--        <app-material-input formControlName="lead_transfer_sub_percent_agd" [placeholder]="'Процент субагента АГД при передаче лида'">-->
<!--          Процент субагента АГД при передаче лида-->
<!--        </app-material-input>-->
<!--      </div>-->
<!--    </div>-->
</div>
<hr>

  <div class="caption mb-2">Использовать общие настройки для реализации квартир</div>
  @if (complexes.controls.length) {
    <div class="row mb-2">
      <div class="col-12 col-sm-6 col-lg-3">
        <app-material-input [(ngModel)]="searchField" [ngModelOptions]="{standalone: true}" [error]="searchFieldError">
          Поиск ЖК
          @if (searchField !== '') {
            <span class="ml-3 badge align-top"
              [class.badge-warning]="!searchFieldIds.length"
              [class.badge-success]="searchFieldIds.length"
            >(найдено {{searchFieldIds.length}} из {{complexes.controls.length}})</span>
          }
        </app-material-input>
      </div>
    </div>
  }

  <div class="row no-gutters gutters-4 align-items-center" formArrayName="complexes">
    @if (!complexes.controls.length) {
      <div class="col-12 mb-2 mt-2 text-sm">В данный момент комплексов нет</div>
    }
    @for (complex of complexes.controls; track complex; let id = $index) {
      <div class="col-sm-6"
        [formGroupName]="id"
        [class.d-none]="!searchFieldError && searchField && searchFieldIds.indexOf(complex.value.realty_id) === -1"
        >
        <app-material-input-checkbox formControlName="is_checked" [require]="true">
          {{ complex.value.caption }}
        </app-material-input-checkbox>
      </div>
    }
  </div>
  <div formArrayName="settings" class="end_block_padding">
    <div class="row no-gutters gutters-4 align-items-center">
      @for (setting of settings.controls; track setting; let id = $index) {
        <div class="col-12"
          [formGroupName]="id"
          [class.d-none]="!searchFieldError && searchField && searchFieldIds.indexOf(setting.value.realty_id) === -1"
          >
          <div class="row no-gutters gutters-2 panel bg-white mb-3 p-2 pt-3 pb-3 mr-0 ml-0">
            <div class="col-6 col-sm-12 col-xl-3 caption-sm mb-2 mt-0 pt-2">
              {{setting.value.caption}}
              @if (setting.value.imp_settings && setting.value.imp_settings.length) {
                @for (el of setting.value.imp_settings; track el) {
                  <a
                    class="ml-2"
                    [routerLink]="['/import/edit', el['id'], 'realization']"
                    [title]="el['caption']"
                    >
                    <i class="text-sm icon icon_xml-icon"></i>
                  </a>
                }
              }
            </div>
            <div class="col-6 col-md-3 pt-2">
              <app-material-input-checkbox formControlName="is_active">
                Принимать на реализацию
              </app-material-input-checkbox>
            </div>
            <!--          <div class="col-4">-->
            <!--            <app-material-input formControlName="voznagr_agenta" [placeholder]="'Вознаграждение агента (ДБ)'">-->
            <!--              Вознаграждение агента (ДБ)-->
          <!--            </app-material-input>-->
        <!--          </div>-->
        <!--          <div class="col-4">-->
        <!--            <app-material-input formControlName="dolya_subagenta_db" [placeholder]="'Процент субагента (ДБ)'">-->
        <!--              Процент субагента ДБ (Доля <span class="bold">{{ settings.controls[id].value['voznagr_agenta'] | partRate : settings.controls[id].value['dolya_subagenta_db'] : 'front'}}</span>)-->
      <!--            </app-material-input>-->
    <!--          </div>-->
    <div class="col-sm-6 col-md-3 col-xl-2">
      <app-material-input-datepicker formControlName="date_to" [placeholder]="'Действует до'">
        Действует до
      </app-material-input-datepicker>
    </div>
    <div class="col-6 col-md-3 col-xl-2">
      <app-material-input formControlName="flat_agent_ddu_percent" [placeholder]="'Вознаграждение агента (ДДУ)'">
        Вознаграждение агента (ДДУ)
      </app-material-input>
    </div>
    <div class="col-6 col-md-3 col-xl-2">
      <app-material-input formControlName="flat_sa_agd_percent" [placeholder]="'Процент субагента (АГД)'">
        Процент субагента АГД (Доля <span class="bold">{{ settings.controls[id].value['flat_agent_ddu_percent'] | partRate : settings.controls[id].value['flat_sa_agd_percent'] : 'front'}}</span>)
      </app-material-input>
    </div>
    <!--          <div class="col-sm-12">-->
    <!--            <app-material-input formControlName="unique_term_days" [placeholder]="'Срок уникальности клиента'">-->
    <!--              Срок уникальности клиента-->
  <!--            </app-material-input>-->
<!--          </div>-->
<!--          <div class="col-sm-12">-->
<!--            <app-material-input-checkbox formControlName="lead_transfer_capability">-->
<!--              Возможность передачи лида субагентом-->
<!--            </app-material-input-checkbox>-->
<!--          </div>-->
<!--          <div class="col-sm-12">-->
<!--            <div [hidden]="!settings.controls[id].value['lead_transfer_capability']">-->
<!--              <app-material-input formControlName="lead_transfer_sub_percent_db" [placeholder]="'Процент субагента ДБ при передаче лида'">-->
<!--                Процент субагента ДБ при передаче лида-->
<!--              </app-material-input>-->
<!--              <app-material-input formControlName="lead_transfer_sub_percent_agd" [placeholder]="'Процент субагента АГД при передаче лида'">-->
<!--                Процент субагента АГД при передаче лида-->
<!--              </app-material-input>-->
<!--            </div>-->
<!--          </div>-->
</div>
</div>
}
</div>
</div>
<div class="row no-gutters gutters-4 align-items-center mt-4 mb-4">
  <div class="col-6">
    <button (click)="saveForm()" type="button" [disabled]="loading"
      class="button fixed_buttons_block_main" [ngClass]="{'button_disabled': loading}">
      Сохранить
    </button>
  </div>
</div>
</form>
